import { GraphUtils } from '@helpers/graph.helper';
import { Sensor } from '../sensor/sensor';
import { Router } from '@angular/router';
import { UtilsHelper } from '@helpers/utils.helper';

export class VoltageAttribute extends Sensor {
  public voltageChart: any;
  private voltageSensor: any[];
  public iconsToDisplay: { icon: string, type: number }[] = [];

  constructor(router: Router, url: string, alertsActive: boolean) {
    super(router, url, alertsActive);
    this.voltageChart = null;
    this.voltageSensor = [];
  }

  private ensureArraySize(arr: any[], position: number): void {
    while (arr.length <= position) {
      arr.push([]);
    }
  }

  public prepareData(): void {
    const iconMap = new Map<string, { icon: string, type: number }>();
    for (const element of this.data) {
      const date = new Date(element.date);
      const timestamp = GraphUtils.getDateUtc(date);
      const position = element.position;
      const sensorInfo = UtilsHelper.nameSensor(element.type);
      const icon = sensorInfo.icon;

      if (!iconMap.has(icon)) {
        iconMap.set(icon, {
          icon,
          type: element.type
        });
      }

      this.ensureArraySize(this.voltageSensor, position);
      this.voltageSensor[position].push([timestamp, element.voltage]);
    }
    this.iconsToDisplay = Array.from(iconMap.values());
  }

  public setCharts(): void {
    const filteredVoltage = this.voltageSensor.filter(series => series.length > 0);

    const positionNodeVoltage = this.voltageSensor
      .map((item, index) => (item.length > 0 ? index + 1 : -1))
      .filter(index => index !== -1);

    this.voltageChart = this.getConfigChar(
      'voltage',
      this.getChartSeriesNewNode('Sensor', filteredVoltage, positionNodeVoltage),
      this.getRanges('voltage'),
      this.getLimits('voltage')
    );
  }

  public hasVoltageSensor(pos: number): boolean {
    const index = pos - 1;
    return (
      index >= 0 &&
      index < this.voltageSensor.length &&
      this.voltageSensor[index].length > 0
    );
  }

  public getVoltageSensor(pos: number): any {
    const index = pos - 1;
    if (index >= 0 && index < this.voltageSensor.length) {
      const sensorData = this.voltageSensor[index];
      if (sensorData.length > 0) {
        return sensorData[sensorData.length - 1][1] ?? null;
      }
    }
    return null;
  }

  public static getVariables(): any[] {
    return [
      { title: 'Voltios', value: 'voltage' }
    ];
  }
}
